import styled from '@emotion/styled';
import { GNB_HEIGHT } from 'components/GNB';
import { fadeIn } from 'utils/customAnimation';
import { CUSTOM_BREAK_POINT, MOBILE_BREAK_POINT } from '../Block.styled';

const ImageCommon = styled.img`
  position: absolute;
`;

const Images = {
  WelGgome: styled(ImageCommon)`
    /* top: calc(334px - ${GNB_HEIGHT}px); */
    /* left: 790px; */
    transform: scale(0.9) translateY(14px);
    top: 20px;
    left: 10px;
  `,
  GummyBox: styled(ImageCommon)`
    /* top: calc(437px - ${GNB_HEIGHT}px); */
    /* left: 777px; */
    top: 130px;
  `,
  GummyNoise: styled(ImageCommon)`
    /* top: calc(484px - ${GNB_HEIGHT}px); */
    /* left: 780px; */
    /* left: 342px; */
    width: 352px;
    height: 347px;
    opacity: 0.5;
    top: 177px;
    left: 3px;
  `,
  GummyBorder: styled(ImageCommon)`
    /* top: calc(499px - ${GNB_HEIGHT}px); */
    /* left: 806px; */
    top: 180px;
    left: 25px;
  `,
  GummyPrivate: styled(ImageCommon)`
    /* top: calc(510px - ${GNB_HEIGHT}px); */
    /* left: 817px; */
    top: 160px;
    left: 35px;
  `,
  Gummy: styled(ImageCommon)`
    /* top: calc(510px - ${GNB_HEIGHT}px); */
    /* left: 817px; */
    top: 190px;
    left: 35px;

    opacity: 0;
    animation: 1.3s ease 0.2s normal forwards 1 ${fadeIn};
  `,
  LetsBox: styled(ImageCommon)`
    /* top: calc(463px - ${GNB_HEIGHT}px); */
    /* left: 1061px; */
    /* right: 200px; */
    top: 120px;
    left: 270px;

    visibility: visible;

    @media (max-width: ${MOBILE_BREAK_POINT}px) {
      visibility: hidden;
    }
  `,
  LetsFlower: styled(ImageCommon)`
    /* top: calc(443px - ${GNB_HEIGHT}px); */
    /* left: 1233px; */
    /* right: 225px; */
    top: 90px;
    left: 420px;

    visibility: visible;

    @media (max-width: ${MOBILE_BREAK_POINT}px) {
      visibility: hidden;
    }
  `,
  LetsText: styled(ImageCommon)`
    /* top: calc(475px - ${GNB_HEIGHT}px); */
    /* left: 1082px; */
    /* right: 240px; */
    top: 132px;
    left: 290px;

    visibility: visible;

    @media (max-width: ${MOBILE_BREAK_POINT}px) {
      visibility: hidden;
    }
  `,
  GummyLeftFlower: styled(ImageCommon)`
    /* top: calc(720px - ${GNB_HEIGHT}px); */
    /* left: 743px; */
    /* left: 305px; */
    top: 190px;
    left: -35px;
  `,
  GummyLeftFlower2: styled(ImageCommon)`
    top: 250px;
    left: -35px;
    transform: rotate(30deg) scale(0.6);
  `,
  GummyRightFlower: styled(ImageCommon)`
    /* top: calc(755px - ${GNB_HEIGHT}px); */
    /* left: 1108px; */
    /* right: 320px; */
    top: 430px;
    left: 330px;
  `,
  Smile: styled(ImageCommon)`
    /* top: calc(571px - ${GNB_HEIGHT}px); */
    /* left: 1108px; */
    /* right: 327px; */
    top: 230px;
    left: 335px;
  `,
  Smile_2: styled(ImageCommon)`
    /* top: calc(621px - ${GNB_HEIGHT}px); */
    /* left: 1108px; */
    /* right: 327px; */
    top: 280px;
    left: 335px;
  `,
  Background: styled(ImageCommon)`
    width: 100%;
    min-width: 1920px;
    height: 230px;
    bottom: 0px;
  `,
  BgFlower: styled(ImageCommon)<{ top: number; left: number }>`
    top: calc(${(props) => `${props.top}px`} - ${GNB_HEIGHT}px);
    left: ${(props) => `${props.left}px`};
  `,
  BgStar: styled(ImageCommon)<{
    top: number;
    left?: number;
    right?: number | string;
  }>`
    top: calc(${(props) => `${props.top}px`} - ${GNB_HEIGHT}px);
    left: ${(props) => `${props.left}px`};
    right: ${(props) => props.right};
    visibility: visible;

    @media (max-width: ${CUSTOM_BREAK_POINT}px) {
      visibility: hidden;
    }
  `,
  Cloud: styled(ImageCommon)`
    top: calc(306px - ${GNB_HEIGHT}px);
    /* left: 382px; */
    left: -95px;

    visibility: visible;

    @media (max-width: ${MOBILE_BREAK_POINT}px) {
      visibility: hidden;
    }
  `,
  Rainbow: styled(ImageCommon)`
    top: calc(291px - ${GNB_HEIGHT}px);
    /* left: 1390px; */
    right: -160px;

    visibility: visible;

    @media (max-width: ${MOBILE_BREAK_POINT}px) {
      visibility: hidden;
    }
  `,
  Sticker: styled(ImageCommon)`
    top: calc(710px - ${GNB_HEIGHT}px);
    right: -200px;

    visibility: visible;

    @media (max-width: ${MOBILE_BREAK_POINT}px) {
      visibility: hidden;
    }
  `,
  WelGgome_2: styled(ImageCommon)`
    top: calc(720px - ${GNB_HEIGHT}px);
    right: -130px;
    visibility: visible;

    @media (max-width: ${MOBILE_BREAK_POINT}px) {
      visibility: hidden;
    }
  `,
  Progress: styled(ImageCommon)`
    /* top: calc(849px - ${GNB_HEIGHT}px); */
    /* left: 803px; */
    top: 542px;
    left: 20px;
  `,
  Heart: styled(ImageCommon)`
    /* top: calc(842px - ${GNB_HEIGHT}px); */
    /* left: 1075px; */
    top: 537px;
    right: 25px;
  `,
  GommingSoon: styled(ImageCommon)`
    top: 95px;
    left: 245px;

    @media (max-width: ${MOBILE_BREAK_POINT}px) {
      top: 65px;
      left: 220px;
      scale: 0.7;
    }
  `,
  Line: styled.rect`
    visibility: visible;

    @media (max-width: ${CUSTOM_BREAK_POINT}px) {
      visibility: hidden;
    }
  `,
};

export default Images;
